import { Component, OnInit, Input ,ViewChild } from '@angular/core';
import {FormService} from '../../services/form.service';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { Form } from '../../shared/form/form.model';
import { IdWatchService } from './../../services/watch.service'
import { LeadsComponent } from './../leads/leads.component'
@Component({
	selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.css'],
  providers: [
    IdWatchService
  ]
})
export class FormsComponent implements OnInit {
 // leads: LeadsComponent;
  @ViewChild(LeadsComponent) leads: LeadsComponent;
  public form:Form;
  bandera: boolean
  constructor(idWatchService: IdWatchService,formService:FormService) {
    idWatchService.idChange.subscribe(id => {
      formService.getForm(id)
      .subscribe((data:any)=> {
        this.form = data.data;
        this.bandera=true;
        this.leads.formId= this.form._id;
        this.leads.filters.form_id=this.form._id;
        this.leads.ngOnInit();
       // this. ngOnInit();
      
    });
  });

}

  ngOnInit(): void {
   
    let data = localStorage.getItem('form');
    this.form = new Form().deserialize(JSON.parse(data));
   
  }
  
}


// WEBPACK FOOTER //
// ./src/app/components/forms/forms.component.ts